import Header from 'commons/card/Header';
import GenericGrid from 'pages/tables/GenericGrid';
import PropTypes from 'prop-types';
import React, { Fragment, useState } from 'react';
import CreateAnnonceModal from '../modals/CreateAnnonceModal';
import { useUpdateAnnoncesVigueurMutation } from '../../../../redux/api/cache';

export default function Annonce(props) {
  const [data] = useState(props.data);
  const [createModal, setCreateModal] = useState(false);
  const [updateAnnonceVigueur] = useUpdateAnnoncesVigueurMutation();

  const fileClicked = (rowData) => {
    window.open(`/#/Publicite/Annonces/Numero=${rowData.ann_num}`, '_blank');
  };

  const create = async (values) => {
    let datas = values.addedData.concat(values.allData);
    setCreateModal(false);
    await updateAnnonceVigueur(datas);
  };

  return (
    <Fragment>
      {createModal && (
        <CreateAnnonceModal
          save={create}
          media={props.mediaKey}
          annonce={props.project}
          toggleDialog={() => {
            setCreateModal(!createModal);
          }}
        />
      )}
      <Header title={props.title}></Header>
      <GenericGrid
        autoSize={true}
        showCreateBtn={true}
        onCreateClick={() => setCreateModal(true)}
        rowClicked={fileClicked}
        definition={data.meta.definition}
        txtBtn="Ajouter une annonce"
        data={data.data}
      />
    </Fragment>
  );
}

Annonce.propTypes = {
  data: PropTypes.object,
  mediaKey: PropTypes.string,
  project: PropTypes.object,
  title: PropTypes.string,
};
